const Accordion = (accordion: HTMLElement) => {
  const button: HTMLElement = accordion.querySelector(".accordion-button");
  const body: HTMLElement = accordion.querySelector(".body");
  const content: HTMLElement = accordion.querySelector(".content");

  if (button) {
    button.addEventListener("click", () => {
      accordion.parentElement.childNodes.forEach(() => {
        accordion.classList.remove("expanded");
      });
      if (accordion.classList.contains("collapsed")) {
        expand();
      } else {
        collapse();
      }
    });
  }

  const expand = () => {
    accordion.classList.remove("collapsed");
    accordion.classList.add("expanded");
    button.setAttribute("aria-expanded", "true");
    body.style.height = `${body.scrollHeight}px`;
    window.addEventListener("resize", changeHeight, true);
  };

  const collapse = () => {
    accordion.classList.remove("expanded");
    accordion.classList.add("collapsed");
    button.setAttribute("aria-expanded", "false");
    window.removeEventListener("resize", changeHeight, true);
    body.style.height = `${body.scrollHeight}px`;
    body.style.height = "0px";
  };

  const changeHeight = () => {
    body.style.height = `${content.scrollHeight}px`;
  };

  if (
    window.location.hash
    && (accordion.querySelector(".header h4") as HTMLElement).innerText
      === decodeURIComponent(window.location.hash.slice(1))
  ) {
    expand();
    accordion.scrollIntoView();
  }
};

export default Accordion;
